import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";

export const fetchCompanies = createAsyncThunk(
  "companies/fetchCompanies",
  async () => {
    const response = await apiCustom.get("company-approved");
    return response.data?.data?.data?.users;
  }
);
export const createCompanies = createAsyncThunk(
  "companies/createCompanies",
  async (newPost, { rejectWithValue }) => {
    try {
      const response = await apiCustom.post("/company-create", newPost);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const updateCompanies = createAsyncThunk(
  "companies/updateCompanies",
  async ({ id, newPost }, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put(
        `/company-update-by-id/${id}`,
        newPost
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
export const deleteCompanies = createAsyncThunk(
  "companies/deleteCompanies",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.delete(`/company-delete/${id}`);
      return { response };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

export const getCompanyByUserId = createAsyncThunk(
  "companies/getCompanyByUserId",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.get(
        `/company-show-by-user-id?userId=${id}`
      );
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

const companiesSlice = createSlice({
  name: "companies",
  initialState: {
    companies: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanies.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.companies = action.payload;
      })
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(createCompanies.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(deleteCompanies.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(updateCompanies.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(getCompanyByUserId.fulfilled, (state) => {
        state.status = "idle";
      });
  },
});

export default companiesSlice.reducer;
